import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { LoadingStateProps } from '../../types';
import { popupStyles } from '../styles/popupStyles';
import { MESSAGES } from '../constants';

const styles = (theme: any) => ({
  loadingContainer: popupStyles(theme).loadingContainer,
  loadingMessage: popupStyles(theme).loadingMessage,
});

const LoadingState: React.FC<LoadingStateProps & { classes: any }> = ({ classes, message = MESSAGES.LOADING }) => {
  return (
    <div className={classes.loadingContainer}>
      <CircularProgress color="primary" size={32} />
      <div className={classes.loadingMessage}>{message}</div>
    </div>
  );
};

export default withStyles(styles)(LoadingState);
